import React from "react";
import { useTranslation } from "react-i18next";
import {
  Directions,
  subscriptionTypeConstants,
  translationConstants,
} from "../../../constants";

const FreelancerPricingModal = (props) => {
  const { t } = useTranslation();
  return (
    <div className="freelance-instructor-model-sm">
      <p className="pricing-heading mt-3">
        {t(translationConstants.PRICING_BREAKDOWN)}
      </p>
      <hr />
      <div className="d-flex justify-content-between mt-4">
        <p className="subscritption">
          {t(translationConstants.SUBSCRITION_FEE)}
          <span>({t(translationConstants.YEAR)})</span>
        </p>
        <span className="sar">({translationConstants.SAR})</span>
      </div>
      {props?.priceBreakdown?.sports?.map((data) => {
        return (
          <>
            <div className="d-flex justify-content-between mt-3">
              <p>
                {data.sport === subscriptionTypeConstants.SAILING
                  ? t(translationConstants.sailing)
                  : data.sport === subscriptionTypeConstants.KITE_SURFING
                  ? t(translationConstants.kitesurfing)
                  : data.sport === subscriptionTypeConstants.WING_FOILING
                  ? t(translationConstants.wingfoiling)
                  : data.sport === subscriptionTypeConstants.WIND_SURFING
                  ? t(translationConstants.windsurfing)
                  : ""}
              </p>
              <p>{data?.price}</p>
            </div>
            <hr />
          </>
        );
      })}
      <div className="mt-4">
        <div className="d-flex justify-content-between w-100">
          <div>
            <p className="footer-text">{t(translationConstants.SUB_TOTAL)}</p>
          </div>
          <div>
            <p className="footer-text">
              {props?.priceBreakdown?.subTotal?.toFixed(2)}
            </p>
          </div>
        </div>
        <div className="d-flex justify-content-between w-100">
          <div>
            <p className="footer-text">
              {t(translationConstants.VAT)}{" "}
              <span dir={Directions.ltr}>
                ({props?.priceBreakdown?.vatPercentage}%)
              </span>
            </p>
          </div>
          <div>
            <p className="footer-text">
              {props?.priceBreakdown?.vatPrice?.toFixed(2)}
            </p>
          </div>
        </div>
        <div className="d-flex justify-content-between w-100">
          <div>
            <p className="footer-text">{t(translationConstants.TOTAL_FEE)}</p>
          </div>
          <div>
            <p className="footer-text">
              {props?.priceBreakdown?.totalPrice?.toFixed(2)}
            </p>
          </div>
        </div>
      </div>
      <div className="text-center mt-3 font-8">
        {`${t(translationConstants.VAT)}: ${process.env.REACT_APP_VAT_NO}`}
      </div>
    </div>
  );
};

export default FreelancerPricingModal;
